<template>
  <div class="">
    <Navgar />
    <Home></Home>
    <Services> </Services>
    <Contact> </Contact>
    <router-view></router-view>
  </div>
</template>

<script>
import Navgar from "../../components/Navgar/Navgar.vue";
import Home from "../../views/Home.vue";
import Services from "../../views/Services.vue";
import Contact from "../../views/Contact.vue";
import HomeAPI from "../../api/home.js";

export default {
  components: {
    Navgar,
    Home,
    Services,
    Contact,
  },
  methods: {},
};
</script>

<style lang="less" scoped></style>
